import apiUrl from '../../../constants'
import axios from 'axios'
export default new class {

	async getWarehouseList(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getClientList(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getDetailsForRTOGRC(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getDetailsForRTOGRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async validateProuctGRCRTO(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'validateProuctGRCRTO',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getImageEntry(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'addImageEntry',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async addImageEntry(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'addimage',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async qcRTO(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'saveReturnsRTOGR',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async closeRTOGR(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'closeRTOGR',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getDetailsForSRGRC(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getDetailsForSRGRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async validateOrderIdForSRGRC(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'validateOrderIdForSRGRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async updateOrderIdRVPGRN(token, input) {
		try {
			const result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'updateOrderIdRVPGRN',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async updateOrderIdFlagSRReturn(token, input) {
		try {
			const result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'updateOrderIdFlagSRReturn',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async validateProductForSRGRC(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'validateProductForSRGRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async printLabelNOP(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.local_printer_api_url + 'printnopproduct',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async saveSRGRC(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'saveSRGRC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async closeGRCSR(token, input) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'closeGRCSR',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

}


// WEBPACK FOOTER //
// ./src/views/components/rtogrn/rtogrn.js